import React, { useState, useEffect, useRef } from "react";
import api from "../api";

const COUNTRY_CODES = [
  { code: "+1", country: "US", flag: "\u{1F1FA}\u{1F1F8}", name: "United States", digits: 10 },
  { code: "+1", country: "CA", flag: "\u{1F1E8}\u{1F1E6}", name: "Canada", digits: 10 },
  { code: "+44", country: "GB", flag: "\u{1F1EC}\u{1F1E7}", name: "United Kingdom", digits: 10 },
  { code: "+33", country: "FR", flag: "\u{1F1EB}\u{1F1F7}", name: "France", digits: 9 },
  { code: "+49", country: "DE", flag: "\u{1F1E9}\u{1F1EA}", name: "Germany", digits: 10 },
  { code: "+34", country: "ES", flag: "\u{1F1EA}\u{1F1F8}", name: "Spain", digits: 9 },
  { code: "+39", country: "IT", flag: "\u{1F1EE}\u{1F1F9}", name: "Italy", digits: 10 },
  { code: "+31", country: "NL", flag: "\u{1F1F3}\u{1F1F1}", name: "Netherlands", digits: 9 },
  { code: "+32", country: "BE", flag: "\u{1F1E7}\u{1F1EA}", name: "Belgium", digits: 9 },
  { code: "+41", country: "CH", flag: "\u{1F1E8}\u{1F1ED}", name: "Switzerland", digits: 9 },
  { code: "+43", country: "AT", flag: "\u{1F1E6}\u{1F1F9}", name: "Austria", digits: 10 },
  { code: "+351", country: "PT", flag: "\u{1F1F5}\u{1F1F9}", name: "Portugal", digits: 9 },
  { code: "+353", country: "IE", flag: "\u{1F1EE}\u{1F1EA}", name: "Ireland", digits: 9 },
  { code: "+46", country: "SE", flag: "\u{1F1F8}\u{1F1EA}", name: "Sweden", digits: 9 },
  { code: "+47", country: "NO", flag: "\u{1F1F3}\u{1F1F4}", name: "Norway", digits: 8 },
  { code: "+45", country: "DK", flag: "\u{1F1E9}\u{1F1F0}", name: "Denmark", digits: 8 },
  { code: "+358", country: "FI", flag: "\u{1F1EB}\u{1F1EE}", name: "Finland", digits: 9 },
  { code: "+48", country: "PL", flag: "\u{1F1F5}\u{1F1F1}", name: "Poland", digits: 9 },
  { code: "+420", country: "CZ", flag: "\u{1F1E8}\u{1F1FF}", name: "Czechia", digits: 9 },
  { code: "+36", country: "HU", flag: "\u{1F1ED}\u{1F1FA}", name: "Hungary", digits: 9 },
  { code: "+40", country: "RO", flag: "\u{1F1F7}\u{1F1F4}", name: "Romania", digits: 9 },
  { code: "+30", country: "GR", flag: "\u{1F1EC}\u{1F1F7}", name: "Greece", digits: 10 },
  { code: "+61", country: "AU", flag: "\u{1F1E6}\u{1F1FA}", name: "Australia", digits: 9 },
  { code: "+64", country: "NZ", flag: "\u{1F1F3}\u{1F1FF}", name: "New Zealand", digits: 9 },
  { code: "+81", country: "JP", flag: "\u{1F1EF}\u{1F1F5}", name: "Japan", digits: 10 },
  { code: "+82", country: "KR", flag: "\u{1F1F0}\u{1F1F7}", name: "South Korea", digits: 10 },
  { code: "+86", country: "CN", flag: "\u{1F1E8}\u{1F1F3}", name: "China", digits: 11 },
  { code: "+852", country: "HK", flag: "\u{1F1ED}\u{1F1F0}", name: "Hong Kong", digits: 8 },
  { code: "+65", country: "SG", flag: "\u{1F1F8}\u{1F1EC}", name: "Singapore", digits: 8 },
  { code: "+60", country: "MY", flag: "\u{1F1F2}\u{1F1FE}", name: "Malaysia", digits: 10 },
  { code: "+91", country: "IN", flag: "\u{1F1EE}\u{1F1F3}", name: "India", digits: 10 },
  { code: "+971", country: "AE", flag: "\u{1F1E6}\u{1F1EA}", name: "UAE", digits: 9 },
  { code: "+966", country: "SA", flag: "\u{1F1F8}\u{1F1E6}", name: "Saudi Arabia", digits: 9 },
  { code: "+972", country: "IL", flag: "\u{1F1EE}\u{1F1F1}", name: "Israel", digits: 9 },
  { code: "+55", country: "BR", flag: "\u{1F1E7}\u{1F1F7}", name: "Brazil", digits: 11 },
  { code: "+52", country: "MX", flag: "\u{1F1F2}\u{1F1FD}", name: "Mexico", digits: 10 },
  { code: "+54", country: "AR", flag: "\u{1F1E6}\u{1F1F7}", name: "Argentina", digits: 10 },
  { code: "+56", country: "CL", flag: "\u{1F1E8}\u{1F1F1}", name: "Chile", digits: 9 },
  { code: "+57", country: "CO", flag: "\u{1F1E8}\u{1F1F4}", name: "Colombia", digits: 10 },
  { code: "+27", country: "ZA", flag: "\u{1F1FF}\u{1F1E6}", name: "South Africa", digits: 9 },
  { code: "+234", country: "NG", flag: "\u{1F1F3}\u{1F1EC}", name: "Nigeria", digits: 10 },
  { code: "+20", country: "EG", flag: "\u{1F1EA}\u{1F1EC}", name: "Egypt", digits: 10 },
  { code: "+212", country: "MA", flag: "\u{1F1F2}\u{1F1E6}", name: "Morocco", digits: 9 },
  { code: "+7", country: "RU", flag: "\u{1F1F7}\u{1F1FA}", name: "Russia", digits: 10 },
  { code: "+380", country: "UA", flag: "\u{1F1FA}\u{1F1E6}", name: "Ukraine", digits: 9 },
  { code: "+90", country: "TR", flag: "\u{1F1F9}\u{1F1F7}", name: "Turkey", digits: 10 },
  { code: "+63", country: "PH", flag: "\u{1F1F5}\u{1F1ED}", name: "Philippines", digits: 10 },
  { code: "+66", country: "TH", flag: "\u{1F1F9}\u{1F1ED}", name: "Thailand", digits: 9 },
  { code: "+84", country: "VN", flag: "\u{1F1FB}\u{1F1F3}", name: "Vietnam", digits: 9 },
  { code: "+62", country: "ID", flag: "\u{1F1EE}\u{1F1E9}", name: "Indonesia", digits: 11 },
];

interface PhonePromptModalProps {
  onSaved?: (phoneNumber: string) => void;
  onDismiss?: () => void;
}

export default function PhonePromptModal({ onSaved, onDismiss }: PhonePromptModalProps) {
  const [step, setStep] = useState<1 | 2>(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState(COUNTRY_CODES[0]);
  const [otpCode, setOtpCode] = useState("");
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState("");
  const [cooldown, setCooldown] = useState(0);
  const cooldownRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Cooldown timer
  const cooldownActive = cooldown > 0;
  useEffect(() => {
    if (cooldownActive) {
      cooldownRef.current = setInterval(() => {
        setCooldown((c) => {
          if (c <= 1) {
            if (cooldownRef.current) clearInterval(cooldownRef.current);
            return 0;
          }
          return c - 1;
        });
      }, 1000);
    }
    return () => {
      if (cooldownRef.current) clearInterval(cooldownRef.current);
    };
  }, [cooldownActive]);

  const fullPhone = `${countryCode.code}${phoneNumber}`;
  const isPhoneValid = phoneNumber.length === countryCode.digits;
  const isCodeValid = /^\d{6}$/.test(otpCode);

  const handleDismiss = () => {
    setPhoneNumber("");
    setCountryCode(COUNTRY_CODES[0]);
    setOtpCode("");
    setStep(1);
    setError("");
    onDismiss?.();
  };

  const handleSendCode = async () => {
    if (!isPhoneValid) return;
    setSending(true);
    setError("");
    try {
      await api.post("/auth/send-otp", { phoneNumber: fullPhone });
      setStep(2);
      setCooldown(60);
    } catch (e: any) {
      setError(e.response?.data?.msg || "Failed to send code. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const handleVerify = async () => {
    if (!isCodeValid) return;
    setVerifying(true);
    setError("");
    try {
      const { data } = await api.post("/auth/verify-otp", { phoneNumber: fullPhone, code: otpCode });
      onSaved?.(data.phoneNumber);
    } catch (e: any) {
      setError(e.response?.data?.msg || "Verification failed. Please try again.");
      setOtpCode("");
    } finally {
      setVerifying(false);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0) return;
    setSending(true);
    setError("");
    try {
      await api.post("/auth/send-otp", { phoneNumber: fullPhone });
      setCooldown(60);
      setOtpCode("");
    } catch (e: any) {
      setError(e.response?.data?.msg || "Failed to resend code.");
    } finally {
      setSending(false);
    }
  };

  // Auto-verify when 6 digits entered
  const autoVerifyRef = useRef(false);
  const handleVerifyRef = useRef(handleVerify);
  handleVerifyRef.current = handleVerify;
  useEffect(() => {
    if (step === 2 && otpCode.length === 6 && !verifying && !autoVerifyRef.current) {
      autoVerifyRef.current = true;
      handleVerifyRef.current();
    }
    if (otpCode.length < 6) autoVerifyRef.current = false;
  }, [otpCode, step, verifying]);

  // Mask phone for display: +1 ••••••1234
  const maskedPhone = (() => {
    const digits = phoneNumber;
    if (digits.length <= 4) return `${countryCode.code} ${digits}`;
    const visible = digits.slice(-4);
    const hidden = "\u2022".repeat(digits.length - 4);
    return `${countryCode.code} ${hidden}${visible}`;
  })();

  const busy = sending || verifying;

  const inputStyle = {
    boxSizing: "border-box" as const,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 10,
    padding: "12px 14px",
    color: "#fff",
    fontSize: "1rem",
    outline: "none",
  };

  const greenBtnStyle = (enabled: boolean) => ({
    flex: 1,
    padding: "12px 14px",
    borderRadius: 10,
    background: enabled ? "linear-gradient(135deg, #22c55e, #16a34a)" : "rgba(34,197,94,0.3)",
    color: "#fff",
    border: "none",
    cursor: enabled ? "pointer" : "not-allowed",
    fontWeight: 700,
    fontSize: "0.95rem",
  });

  const ghostBtnStyle = {
    flex: 1,
    padding: "12px 14px",
    borderRadius: 10,
    background: "rgba(255,255,255,0.06)",
    color: "#e5e7eb",
    border: "1px solid rgba(255,255,255,0.08)",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: "0.95rem",
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.7)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={() => !busy && handleDismiss()}
    >
      <div
        style={{
          background: "#111827",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.06)",
          borderRadius: 16,
          padding: 24,
          width: "min(92vw, 400px)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ color: "#22c55e", fontWeight: 700, fontSize: "1.1rem", margin: "0 0 12px", textAlign: "center" }}>
          {step === 1 ? "Add SMS Notifications" : "Verify Your Number"}
        </h3>

        {step === 1 ? (
          <>
            <p style={{ color: "#9ca3af", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: 16, textAlign: "center" }}>
              Add your phone number to receive SMS notifications when someone sends you a song request.
            </p>
            <p style={{ color: "#6b7280", fontSize: "0.78rem", marginBottom: 18, textAlign: "center" }}>
              We'll only text you about incoming requests — no ads, no spam.
            </p>

            <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
              <select
                value={`${countryCode.country}-${countryCode.code}`}
                onChange={(e) => {
                  const [country, ...codeParts] = e.target.value.split("-");
                  const code = codeParts.join("-");
                  const found = COUNTRY_CODES.find(c => c.country === country && c.code === code);
                  if (found) {
                    setCountryCode(found);
                    setPhoneNumber("");
                  }
                }}
                disabled={busy}
                style={{
                  width: 130,
                  flexShrink: 0,
                  ...inputStyle,
                  cursor: "pointer",
                }}
              >
                {COUNTRY_CODES.map((c) => (
                  <option key={`${c.country}-${c.code}`} value={`${c.country}-${c.code}`}>
                    {c.flag} {c.code}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                placeholder="Phone number"
                value={phoneNumber}
                onChange={(e) => {
                  const digits = e.target.value.replace(/[^\d]/g, "");
                  if (digits.length <= countryCode.digits) setPhoneNumber(digits);
                }}
                disabled={busy}
                style={{ flex: 1, ...inputStyle }}
                onFocus={(e) => (e.target.style.borderColor = "#22c55e")}
                onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.08)")}
              />
            </div>

            <p style={{ color: "#6b7280", fontSize: "0.75rem", marginBottom: 16, textAlign: "right" }}>
              {phoneNumber.length}/{countryCode.digits} digits
            </p>

            {error && (
              <p style={{ color: "#ef4444", fontSize: "0.85rem", marginBottom: 12, textAlign: "center" }}>{error}</p>
            )}

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleDismiss} disabled={busy} style={ghostBtnStyle}>
                Add Later
              </button>
              <button
                onClick={handleSendCode}
                disabled={!isPhoneValid || busy}
                style={greenBtnStyle(isPhoneValid && !busy)}
              >
                {sending ? "Sending..." : "Send Code"}
              </button>
            </div>
          </>
        ) : (
          <>
            <p style={{ color: "#9ca3af", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: 6, textAlign: "center" }}>
              We sent a 6-digit code to
            </p>
            <p style={{ color: "#fff", fontSize: "0.95rem", fontWeight: 600, marginBottom: 4, textAlign: "center", letterSpacing: "0.05em" }}>
              {maskedPhone}
            </p>
            <button
              onClick={() => { setStep(1); setOtpCode(""); setError(""); }}
              style={{ display: "block", margin: "0 auto 18px", background: "none", border: "none", color: "#22c55e", fontSize: "0.82rem", cursor: "pointer", fontWeight: 600 }}
            >
              Change number
            </button>

            <input
              type="tel"
              placeholder="000000"
              maxLength={6}
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value.replace(/[^\d]/g, ""))}
              disabled={verifying}
              autoFocus
              style={{
                ...inputStyle,
                width: "100%",
                textAlign: "center",
                letterSpacing: "0.5em",
                fontSize: "1.4rem",
                fontWeight: 700,
                marginBottom: 12,
              }}
              onFocus={(e) => (e.target.style.borderColor = "#22c55e")}
              onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.08)")}
            />

            {error && (
              <p style={{ color: "#ef4444", fontSize: "0.85rem", marginBottom: 12, textAlign: "center" }}>{error}</p>
            )}

            <button
              onClick={handleResend}
              disabled={cooldown > 0 || sending}
              style={{
                display: "block",
                margin: "0 auto 16px",
                background: "none",
                border: "none",
                color: cooldown > 0 ? "#6b7280" : "#22c55e",
                fontSize: "0.82rem",
                cursor: cooldown > 0 ? "default" : "pointer",
                fontWeight: 600,
              }}
            >
              {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend Code"}
            </button>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleDismiss} disabled={busy} style={ghostBtnStyle}>
                Cancel
              </button>
              <button
                onClick={handleVerify}
                disabled={!isCodeValid || verifying}
                style={greenBtnStyle(isCodeValid && !verifying)}
              >
                {verifying ? "Verifying..." : "Verify"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
